const AmyAspectRatio = {
  Rect_16x9: 1.78,
  Square: 1.0,
  Rect_2x1: 2.0,
  Rect_1x2: 0.5,
  Rect_2x3: 2/3,
};

export default AmyAspectRatio;
